module.exports = __webpack_public_path__ + "_assets/img/ptTaoyuanW.b7ca37b4.svg";